/**
 * 判断是否为编辑器
 */
function isEditor() {
    return !!window.FEGOEditor;
}

/**
 * 判断H5还是Web模式
 * @returns
 */
function isPc() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        return parseInt(window.FEGOEditor.app.project.route.now.pageType, 2) === 2;
    } else {
        return parseInt(window.FEGORender.store.route.now.pageType, 2) === 2;
    }
}
/**
 * 获取当前的页面语言情况
 * @returns
 */
function getPageLang() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        return window.FEGOEditor.app.project.route.now.lang;
    } else {
        return window.FEGORender.store.route.now.lang;
    }
}

/**
 * 判断是否为scheme链接
 * @param {string} url
 * @returns {boolean}
 */
function isScheme(url) {
    return /^ftnn:\/\//.test(url) || /^futunn:\/\//.test(url) || /^ftmm:\/\//.test(url) || /^futumm:\/\//.test(url);
}

export { isEditor, isPc, getPageLang, isScheme };
